<template>
    <section>
        <Header title="Profielen" show-back-button></Header>
        <v-container class="pt-0 pt-md-4">
            <p v-if="isLoading" class="text-center my-7"><v-icon large color="primary">fal fa-spinner-third fa-spin</v-icon></p>
            <v-breadcrumbs :items="breadcrumbs" class="px-0"></v-breadcrumbs>
            <v-row v-if="!isLoading">
                <v-col class="col-12 col-md-4 col-lg-3 px-0 px-md-4 pb-0">
                    <FilterPopup></FilterPopup>
                    <FilterList class="d-none d-md-block"></FilterList>
                </v-col>
                <v-col class="col-12 col-md-8 col-lg-9">
                    <ProfileList></ProfileList>
                </v-col>
            </v-row>
        </v-container>
    </section>
</template>

<script>
import Header from "@/components/layout/Header";
import ProfileList from "@/components/profile/ProfileList";
import FilterList from "@/components/profile/FilterList";
import {mapState} from "vuex";
import FilterPopup from "../components/profile/FilterPopup";

export default {
    name: 'Profiles',
    components: {
        FilterPopup,
        FilterList,
        ProfileList,
        Header,
    },
    data: () => ({
        isLoading: true,
        breadcrumbs: [
            {
                text: 'Dashboard',
                disabled: false,
                exact: true,
                to: {
                    name: 'Home'
                }
            },
            {
                text: 'Profielen',
                disabled: true,
                exact: true,
                to: {
                    name: 'Profiles'
                }
            }
        ],
    }),
    watch: {
        filters: {
            handler () {
                if (!this.isLoading) {
                    this.updateRouteQuery();
                }
            },
            deep: true,
        },
        profilePage () {
            if (!this.isLoading) {
                this.updateRouteQuery();
            }
        },
        '$route.query' () {
            this.initializeSelectedFacets();
        },
    },
    mounted () {
        if (this.isLoggedIn) {
            this.$store.dispatch('updateProfiles')
                .catch(e => {
                    console.error(e);

                    // Bij een 401 is de sessie verlopen; de api-client logt uit en
                    // stuurt door naar het inlogscherm. Daar hoort geen foutmelding bij.
                    if (e.response && e.response.status === 401) {
                        return;
                    }

                    return this.$store.dispatch('showSnackbar', {
                        color: 'error',
                        text: 'Profielen konden niet worden opgehaald'
                    });
                })
                .finally(() => {
                    this.initializeSelectedFacets();

                    this.$store.dispatch('updateSearchQuery', this.$route.query.query ? this.$route.query.query : null);
                    this.$store.dispatch('updateProfilePage', parseInt(this.$route.query.page ? this.$route.query.page : 1));

                    if (this.$route.query.postalCode) {
                        this.$store.dispatch('updatePostalCode', {
                            code: this.$route.query.postalCode,
                            distance: parseInt(this.$route.query.postalCodeDistance ? this.$route.query.postalCodeDistance : 4),
                        });
                    }

                    this.isLoading = false;
                });
        }
    },
    computed: {
        ...mapState({
            facets: state => state.profile.facets,
            filters: state => state.profile.filters,
            profilePage: state => state.profile.profilePage,
            isLoggedIn: state => state.auth.isLoggedIn,
        }),
    },
    methods: {
        initializeSelectedFacets() {
            const query = this.$route.query;
            this.facets.forEach(facet => {
                let choices = [];

                const index = 'filter' + facet.id;
                if (query[index]) {
                    ('' + query[index]).split(',').forEach(id => {
                        const choice = facet.choices.find(c => c.id === parseInt(id));
                        if (choice) {
                            choices.push(choice.id);
                        }
                    });
                }

                this.$store.dispatch('updateFacetFilter', { facet, choices });
            });
        },
        updateRouteQuery () {
            let query = {
                page: ''+this.profilePage,
            };

            if (this.filters.searchQuery) {
                query.query = this.filters.searchQuery;
            }

            this.facets.forEach(facet => {
                const selectedChoices = this.filters.facetChoices[facet.id];
                if (selectedChoices.length > 0) {
                    query['filter'+facet.id] = selectedChoices.join(',');
                }
            });

            if (this.filters.postalCode.code && this.filters.postalCode.code.length === 6) {
                query.postalCode = this.filters.postalCode.code;
                query.postalCodeDistance = ''+this.filters.postalCode.distance;
            }

            if (JSON.stringify(query) === JSON.stringify(this.$route.query)) {
                return;
            }

            this.$router.replace({ name: 'Profiles', query: query });
        },
    },
}
</script>
